// Порт ref DesignBlockEditor.tsx:318-424: подложка + наклон на обёртке,
// внутри — RichTextEditor с цветами выделений от текущей подложки.
import type { DesignText } from '@/types/blocks'
import { useStrictLang } from './strictLangContext'
import { getLocalizedDisplay, setLocalizedField } from '@/features/editor/lib/localizedField'
import {
  alignClass,
  backdropHighlight,
  backdropTextColor,
  textBoxStyle,
  textSizeClass,
} from '@/features/editor/lib/designElementStyles'
import { TransparentFrame } from './TransparentFrame'
import type { DesignElementProps } from './DesignElementView'
import { DESIGN_TEXT_STUDIO_LIMIT } from '@/features/editor/lib/designElementDefaults'
import { RichTextEditor } from './RichTextEditor'
import { RichTextView } from './RichTextView'
import { useContentMessages } from '@/features/editor/hooks/useContentMessages'
import { messages } from './messages'

export const TextElement = ({
  element,
  editable,
  contentLang,
  onUpdate,
  onSelect,
}: DesignElementProps<DesignText>) => {
  // Симметричный фолбэк только для показа (read-only): бек фолбэка не делает.
  const strictLang = useStrictLang()
  const cm = useContentMessages(messages)
  const shown = getLocalizedDisplay(element, 'content', contentLang, editable || strictLang)

  return (
    <div
      className="relative"
      style={{
        ...textBoxStyle(element.backdrop, element.backdropRounded),
        transform: element.textRotation ? `rotate(${element.textRotation}deg)` : undefined,
        transition: 'transform 0.3s ease',
      }}
    >
      {element.backdrop === 'blur' ? <TransparentFrame rounded={element.backdropRounded} /> : null}
      {editable ? (
        <RichTextEditor
          content={shown}
          placeholder={cm.paragraph}
          maxLength={DESIGN_TEXT_STUDIO_LIMIT}
          onChange={(html) => onUpdate(setLocalizedField('content', contentLang, html))}
          highlight={backdropHighlight(element.backdrop)}
          textColor={backdropTextColor(element.backdrop)}
          textSizeClassName={textSizeClass(element.textSize)}
          textAlignClassName={alignClass(element.textAlign)}
          onFocusChange={(focused) => {
            if (focused) onSelect()
          }}
        />
      ) : (
        <RichTextView
          content={shown}
          highlight={backdropHighlight(element.backdrop)}
          textColor={backdropTextColor(element.backdrop)}
          textSizeClassName={textSizeClass(element.textSize)}
          textAlignClassName={alignClass(element.textAlign)}
        />
      )}
    </div>
  )
}
